export default {
    'POPUP.FINALY.TITLE': 'Well done!',
    'POPUP.FINALY.ASIDE': 'Your new password is now set.',
    'POPUP.FINALY.CLOSE': 'Close',
    'POPUP.FINALY.EVENT.DELETED': 'Event deleted',
    'POPUP.FINALY.EVENT.DELETED.TEXT': 'has been deleted',
};
